// extracted by mini-css-extract-plugin
export var price = "title-module--price--eb6dc";
export var price_full = "title-module--price_full--e1c7c";
export var price_perc = "title-module--price_perc--63054";
export var price_sale = "title-module--price_sale--2143c";
export var shortd = "title-module--shortd--fc7b2";
export var title = "title-module--title--98e10";
export var title_price = "title-module--title_price--5e161";